export default __webpack_public_path__ + "static/media/Img153.cd87dce3.jpg";